import {createContext, useState} from "react";
import {useQuery} from "react-query";
import {cpx} from "../../../../../utils/const/query-key";
import { useLocation } from "react-router-dom";

const EnvironmentContext = createContext();

export function EnvProvider({createCpxEnv, children}) {
    const { data: isCpx} = useQuery(cpx, () =>
            true
        , {staleTime: Infinity}
    );

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let blueprintId;
    let category;
    let region;
    let step;
    if(searchParams.get("blueprintId")!==undefined && searchParams.get("blueprintId") !== null){
        blueprintId = searchParams.get("blueprintId");
    }
    if(searchParams.get("category")!==undefined && searchParams.get("category") !== null){
        category = searchParams.get("category");
    }
    if(searchParams.get("region")!==undefined && searchParams.get("region") !== null){
         region = searchParams.get("region");
    }
    if(searchParams.get("step")!==undefined && searchParams.get("step") !== null){
        step = searchParams.get("step");
    }


    const defaultContext = {
        is_invitation: false,
        customer_email: "",
        region: region || "",
        blueprint: "",
        blueprint_id: "",
        scenario: blueprintId || step? "selfTraining" : "",
        category: category || "",
        environment_type: blueprintId? "training" : "",
        customer_company_name: "",
        salesforceOpportunityID: "",
        salesforceAccountID:""
    }


    const cpxContext = {
        is_invitation: false,
        customer_email: "",
        region: "1",
        blueprint: "",
        blueprint_id: "",
        scenario: "customerDemo",
        category: "",
        environment_type: "Demo",
        customer_company_name: "CPX "+ new Date().toDateString(),
        salesforceOpportunityID: "",
        salesforceAccountID:""
    }
    const environmentContext = (isCpx && createCpxEnv) ? cpxContext : defaultContext ;

    const [environment, setEnvironment] = useState(environmentContext);
    return (
        <EnvironmentContext.Provider value={{environment , setEnvironment}}>{children}</EnvironmentContext.Provider>
    );
}

export default EnvironmentContext;
